<script setup lang="ts">
import { getGameRecordApi } from "@/api/pvp-card";
import { formatMs } from "@/utils";
import { dayjs } from "element-plus";
import { ref } from "vue";
import { GameTypeEnum } from "../services/enum";
import { useUserStore } from "@/stores/modules/user";

const userStore = useUserStore()
const showResult = ref(false);
const gameRecordList = ref<any[]>([]);

const total = ref(0)
const params = ref({ page: 1, pageSize: 10 })
function open() {
  showResult.value = true;
  refreshData()
}
async function refreshData() {
  const res = await getGameRecordApi(params.value);
  gameRecordList.value = res.records.map(item => {
    const isMyColor = item.blueId === userStore.id ? 'blue' : 'red'
    return {
      gameType: item.gameType,
      created: item.created,
      duration: item.duration,
      ourId: isMyColor === 'blue' ? item.blueId : item.redId,
      ourMmr: isMyColor === 'blue' ? item.blueMmr : item.redMmr,
      ourNickname: isMyColor === 'blue' ? item.blueNickname : item.redNickname,
      theirId: isMyColor === 'blue' ? item.redId : item.blueId,
      theirMmr: isMyColor === 'blue' ? item.redMmr : item.blueMmr,
      theirNickname: isMyColor === 'blue' ? item.redNickname : item.blueNickname,
      resultText: item.result === 'draw' ? '平' : (isMyColor === item.result ? '胜' : '败'),
      resultClass: item.result === 'draw' ? 'draw' : (isMyColor === item.result ? 'win' : 'lose'),
    }
  })
  total.value = res.total
}

defineExpose({
  open,
  close
})

function close() {
  showResult.value = false;
}
</script>
<template>
  <el-dialog v-model="showResult" width="100%" style="max-width: 500px">
    <div class="">
      <h2>对决记录</h2>
      <div class="">
        <el-table :data="gameRecordList" border :style="{ width: '100%', height: '49vh' }" size="small">
          <el-table-column prop="result" label="" width="40">
            <template #default="{ row }">
              <div :class="row.resultClass" class="result">
                {{ row.resultText }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="info" label="" width="140">
            <template #default="{ row }">
              <div> {{ GameTypeEnum[row.gameType] }}赛</div>
              <div>
                时间：{{ dayjs(row.created).format('MM月DD日 HH:mm') }}
              </div>
              <div>
                时长：{{ formatMs(row.duration) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ourNickname" label="我方">
            <template #default="{ row }">
              <div :class="row.resultClass">{{ row.ourNickname }}</div>
              <div>{{ row.ourMmr }}💠</div>
            </template>
          </el-table-column>
          <el-table-column prop="theirNickname" label="敌方">
            <template #default="{ row }">
              <div>{{ row.theirNickname ?? '匿名' }}</div>
              <div>{{ row.theirMmr }}💠</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <template #footer>
      <el-pagination :pager-count="5" style="flex:1;" :page-size="params.pageSize" v-model:current-page="params.page"
        size="small" layout="prev, pager, next" :total="total" @change="refreshData" />
    </template>
  </el-dialog>
</template>
<style lang="scss" scoped>
.win {
  color: #0f0;
}

.lose {
  color: #F44336;
}

.draw {
  color: #bbb;
}

.result {
  font-weight: bold;
  font-size: 18px;
}
</style>